import Listing from "../components/inventory/favorite/favList";
import Nav from "../components/inventory/vendor/navbar";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <Listing />
    </div>
  );
};

export default ListingPage;